/* Pricing page corrections.

   templates/page.rockkt-pricing.liquid is 128KB and the Admin API can only
   replace a theme file whole, so it cannot be edited through this route. Same
   position as rockkt-home-v2.css, and the same answer: the corrections live in
   their own file. Loaded from layout/rockkt.liquid behind
   {% if template.suffix == 'rockkt-pricing' %}.

   Four things.

   1. AI credits, on the Managed cards, at the top.
      The numbers were already on the page, buried near the bottom of each
      feature list. They are lifted out of the list and set beside the seat
      count, which is where anyone comparing plans is actually looking. The
      figure is READ FROM THE CARD rather than written here, so this file can
      never disagree with the page. The Managed Enterprise card is the one
      exception: it carries no AI line at all, while the comparison table gives
      it Custom, so that is supplied here to stop the four cards contradicting
      each other.

   2. AI credits, on the Studio cards, where there were none at all.
      Studio runs two meters, not one. studio_credit_ledger.meter is either
      'credit' (a send) or 'lookup' (a paid AI action), and studio_company_
      settings carries monthly_credits and monthly_lookups separately. The page
      only ever showed the first. Lookups are granted at five times the send
      allowance: both live companies match exactly (free 5/25, s100 100/500),
      and that 5x is the ratio the Managed allowances were derived from too. So
      the figure is computed from the allowance already printed on the card
      rather than being a second list of numbers to keep in step.

      The top-up pack is skipped: it is an add-on, not a tier, and multiplying
      its pack size would invent an allowance that does not exist.

   3. SSO, which Rockkt does not offer, in three places.
   4. The negotiated rate, which does not need naming on a price card.

   The new line is given class "pr-users pr-ai": pr-users so it inherits the
   seat line's styling exactly rather than a guess at it, pr-ai as the hook and
   the idempotency guard. Nothing here needs a stylesheet.

   Everything is written to survive running twice, because the Studio/Managed
   switch and the monthly/annual toggle both re-enter the same markup. */
(function () {
  var LOOKUPS_PER_CREDIT = 5;

  function addLine(card, text) {
    if (card.querySelector('.pr-ai')) return;
    var users = card.querySelector('.pr-users');
    if (!users) return;
    var d = document.createElement('div');
    d.className = 'pr-users pr-ai';
    d.textContent = text;
    users.insertAdjacentElement('afterend', d);
  }

  function each(sel, fn) {
    var n = document.querySelectorAll(sel);
    for (var i = 0; i < n.length; i++) fn(n[i]);
  }

  function each2(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i]); }

  function managed() {
    each('#pfFaceManaged .pr-card', function (card) {
      var found = null;
      each2(card.querySelectorAll('.pr-feats li'), function (li) {
        if (found) return;
        var span = li.querySelector('span');
        if (!span) return;
        var m = /^\s*([\d,]+)\s+AI credits\s*\/\s*month\s*$/i.exec(span.textContent);
        if (m) { found = m[1]; li.parentNode.removeChild(li); }
      });
      if (found) addLine(card, '⚡ ' + found + ' AI credits / month');
      else if (card.className.indexOf('t-enterprise') > -1) addLine(card, '⚡ Custom AI credit pool');
    });
  }

  function studio() {
    each('#pfFaceStudio .pr-card', function (card) {
      if (card.className.indexOf('t-topup') > -1) return;
      var cv = card.querySelector('.pr-credit .cv');
      if (!cv) return;
      var m = /^\s*([\d,]+)\s+credits?\s*$/i.exec(cv.textContent);
      if (m) {
        var n = parseInt(m[1].replace(/,/g, ''), 10) * LOOKUPS_PER_CREDIT;
        addLine(card, '⚡ ' + n.toLocaleString('en-GB') + ' AI credits / month');
      } else if (card.className.indexOf('t-senterprise') > -1) {
        addLine(card, '⚡ Custom AI credit pool');
      }
    });
  }

  function claims() {
    /* The Studio Enterprise price card. Was:
       "Negotiated rate - SSO, invoicing, SLA" */
    var cn = document.querySelector('#pfFaceStudio .t-senterprise .pr-credit .cn');
    if (cn && /SSO|Negotiated rate/i.test(cn.textContent)) {
      cn.textContent = 'Invoicing, PO terms and an SLA';
    }

    /* The note under the Studio grid. Trimmed rather than rewritten, so the
       rest of the sentence stays exactly as it was written. */
    var note = document.querySelector('#pfFaceStudio .pr-incl-note');
    if (note && note.textContent.indexOf('SSO') > -1) {
      note.textContent = note.textContent
        .replace('Enterprise adds SSO & 2FA, invoicing & PO terms', 'Enterprise adds invoicing & PO terms');
    }

    /* The "SSO & 2FA" row in the Studio comparison table. Removed rather than
       corrected: SSO does not exist, and 2FA is account level and available to
       everyone, so the row is wrong in both directions and there is nothing
       left in it once both are taken out. */
    each('.pr-compare tr', function (tr) {
      var td = tr.querySelector('td');
      if (td && /^\s*SSO\b/i.test(td.textContent) && tr.parentNode) {
        tr.parentNode.removeChild(tr);
      }
    });
  }

  function run() {
    managed();
    studio();
    claims();
    /* The flip stage sets its own height in JS from the taller face, so it has
       to be told the cards just grew or it will clip the last line. */
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();
